import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
const linkBlockSupportTextStyles = ({ theme }) => css `
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	hyphens: manual;
	color: ${theme.colors.base.textSubtitlesSecondary};
`;
export const StyledLinkBlockSupportText = styled(Typography).attrs({
    tagName: 'span',
    variant: 'support-text',
}) `
	${linkBlockSupportTextStyles}
`;
